module.exports = __webpack_public_path__ + "static/media/ic_google.c2b3426f.svg";